/* import __COLOCATED_TEMPLATE__ from './line.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './line.module.scss';

@classic
@classNames(styles.component)
export default class ClientAttendanceAppointmentLine extends Component {}
